export const GOOGLE_STATIC_MAP_HEIGHT = 400

export const GOOGLE_STATIC_MAP_WIDTH = 640

export const GOOGLE_STATIC_MAP_SCALE = 2

export const GOOGLE_STATIC_MAP_ZOOM = 14
